export enum EntityDialogAction {
  submit = 'submit',
  cancel = 'cancel',
}
